import { createReducer, on, Action } from '@ngrx/store';
import {
  languageList,
  mapiCategoryErrorCodes,
  statesAllowedIso2Countries,
  statesAllowedIso3Countries,
  supportedLocale,
} from '../../config/app-config';
import {
  ClearServiceOptions,
  GetServiceOptionsFailed,
  GetServiceOptionsSuccess,
  UpdateWithdrawCountry,
} from './service-options.actions';
import { ServiceOptionsState, UiConfig } from './service-options.model';

export const initialState: ServiceOptionsState = {
  withdrawCountry: '',
  serviceOptions: [],
  isCashOutAllowed: '',
  depositCountry: '',
  indicativeRateCountry: false,
  cashOutCountries: [],
  cashInCountries: [],
  countriesDetails: null,
  hasError: false,
  isServerDown: false,
  uiConfigs: [],
  features: null,
  config: null
};

const uiConfigs: UiConfig[] = [
  {
    displayFlashPage: false,
    disableCashInCountry: true,
    languageList: languageList,
    mapiCategoryErrorCodes: mapiCategoryErrorCodes,
    notSupportedUSStates: ['US-AK', 'US-HI', 'US-LA', 'US-NY'],
    statesAllowedIso2Countries,
    statesAllowedIso3Countries,
    supportedLocale,
    additionalProperties: {},
  },
];

export function ServiceOptionsReducer(
  state: ServiceOptionsState | undefined,
  action: Action
) {
  return reducer(state, action);
}

export const reducer = createReducer(
  initialState,
  on(
    GetServiceOptionsSuccess,
    (state, { serviceOptionsResponse }) =>
      ({
        ...state,
        ...serviceOptionsResponse,
        uiConfigs: serviceOptionsResponse?.uiConfigs
          ? serviceOptionsResponse?.uiConfigs
          : uiConfigs,
        hasError: !!serviceOptionsResponse?.errors,
      } as ServiceOptionsState)
  ),
  on(
    UpdateWithdrawCountry,
    (state, { withdrawCountry }) =>
      ({
        ...state,
        withdrawCountry: withdrawCountry,
      } as ServiceOptionsState)
  ),
  on(
    GetServiceOptionsFailed,
    (state, { error }) =>
      ({
        ...state,
        hasError: false,
      } as ServiceOptionsState)
  ),
  on(ClearServiceOptions, (state) => initialState)
);
